<template>
    <div class="sec-cont">
        <Head :title="__(title)" />
        <div class="bg-white rounded-md shadow overflow-hidden w-full">
            <form @submit.prevent="update">
                <div class="p-8 flex flex-wrap">
                    <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Slug')" />
                </div>
                <div class="p-8 flex flex-col gap-10">
                    <label for="create__workspace" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Create workspace') }}
                        </div>
                        <div class="relative">
                            <input id="create__workspace" type="checkbox" class="sr-only" v-model="form.create_workspace" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                    </label>
                    <label for="create__project" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Create Project') }}
                        </div>
                        <div class="relative">
                            <input id="create__project" type="checkbox" class="sr-only" v-model="form.create_project" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                    </label>
                    <div class="flex flex-row gap-5 items-center w-full">
                        <label for="create_task" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Create Task') }}
                        </div>
                        <div class="relative">
                            <input id="create_task" type="checkbox" class="sr-only" v-model="form.permissions.tasks.create" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="edit_task" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Edit Task') }}
                        </div>
                        <div class="relative">
                            <input id="edit_task" type="checkbox" class="sr-only" v-model="form.permissions.tasks.edit" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="delete_task" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Delete Task') }}
                        </div>
                        <div class="relative">
                            <input id="delete_task" type="checkbox" class="sr-only" v-model="form.permissions.tasks.delete" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="move_task" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Move Other Task') }}
                        </div>
                        <div class="relative">
                            <input id="move_task" type="checkbox" class="sr-only" v-model="form.permissions.tasks.move" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                    </div>
                    <div class="flex flex-row gap-5 items-center w-full">
                        <label for="create_testcase" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Create TestCase') }}
                        </div>
                        <div class="relative">
                            <input id="create_testcase" type="checkbox" class="sr-only" v-model="form.permissions.testcase.create" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="edit_testcase" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Edit TestCase') }}
                        </div>
                        <div class="relative">
                            <input id="edit_testcase" type="checkbox" class="sr-only" v-model="form.permissions.testcase.edit" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="delete_testcase" class="flex toggle_swtich items-center cursor-pointer">
                        <div class="mr-3 text-sm">
                            {{ __('Delete TestCase') }}
                        </div>
                        <div class="relative">
                            <input id="delete_testcase" type="checkbox" class="sr-only" v-model="form.permissions.testcase.delete" />
                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                        </div>
                        </label>
                        <label for="testscript_testcase" class="flex toggle_swtich items-center cursor-pointer">
                            <div class="mr-3 text-sm">
                                {{ __('TestScript') }}
                            </div>
                            <div class="relative">
                                <input id="testscript_testcase" type="checkbox" class="sr-only" v-model="form.permissions.testcase.testscript" />
                                <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                            </div>
                        </label>
                        <label for="execute_testcase" class="flex toggle_swtich items-center cursor-pointer">
                            <div class="mr-3 text-sm">
                                {{ __('Execute') }}
                            </div>
                            <div class="relative">
                                <input id="execute_testcase" type="checkbox" class="sr-only" v-model="form.permissions.testcase.execute" />
                                <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                            </div>
                        </label>
                    </div>
                </div>
                
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                    <button v-if="!['admin','normal'].includes(role.slug)" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete') }}</button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo() {
        return { title: this.form.name }
    },
    components: {
        LoadingButton,
        TextInput,
        Link,
        Head,
    },
    layout: Layout,
    props: {
        title: String,
        role: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.role.name,
                slug: this.role.slug,
                create_workspace: !!parseInt(this.role.create_workspace),
                create_project: !!parseInt(this.role.create_project),
                permissions: {
                    tasks: {
                        create: this.role.access?.tasks.create || false,
                        edit: this.role.access?.tasks.edit || false,
                        delete: this.role.access?.tasks.delete || false,
                        move: this.role.access?.tasks.move || false,
                    },                    
                    testcase: {
                        create: this.role.access?.testcase.create || false,
                        edit: this.role.access?.testcase.edit || false,
                        delete: this.role.access?.testcase.delete || false,
                        testscript: this.role.access?.testcase.testscript || false,
                        execute: this.role.access?.testcase.execute || false,
                    }
                }
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.route('roles.update', this.role.id))
        },
        destroy() {
            if (confirm('Are you sure you want to delete this role?')) {
                this.$inertia.delete(this.route('roles.destroy', this.role.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this role?')) {
                this.$inertia.put(this.route('roles.restore', this.role.id))
            }
        },
    },
    created() {
        // console.log(this.role)
    }
}
</script>
